export default __webpack_public_path__ + "static/media/centro.ac03a08b.png";